"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TESTindexLabelByValue = exports.Dropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_manager_1 = require("@kawaui/modal-manager");
const portal_1 = __importDefault(require("@kawaui/portal"));
const react_1 = require("react");
const Styled = __importStar(require("./Dropdown.styles"));
const Options_1 = require("./Options");
const getLabelReducer = (map, option) => {
    if (option.value)
        map[option.value] = option.label;
    return map;
};
const flattenReducer = (array, group) => array.concat(group.options);
const indexLabelByValue = (options, groups) => {
    if (options) {
        return options.reduce(getLabelReducer, {});
    }
    if (groups) {
        return groups.reduce(flattenReducer, []).reduce(getLabelReducer, {});
    }
    return;
};
exports.TESTindexLabelByValue = indexLabelByValue;
const Message = ({ children, isError }) => ((0, jsx_runtime_1.jsx)(Styled.Message, { isError: isError, children: children }));
exports.Dropdown = (0, react_1.forwardRef)((props, forwardedRef) => {
    const { errorMessage, fixedIcon: FixedIcon = null, hasError, helperText, icon: Icon, isDisabled, isFullWidth, isNumber, label = '', loading, placement = 'bottom', size = 'large', groups, options, value: initialValue, placeholder, lockPageScroll = false, disablePortal, onChange, open = false, hideOtherContent, onClose } = props, otherProps = __rest(props, ["errorMessage", "fixedIcon", "hasError", "helperText", "icon", "isDisabled", "isFullWidth", "isNumber", "label", "loading", "placement", "size", "groups", "options", "value", "placeholder", "lockPageScroll", "disablePortal", "onChange", "open", "hideOtherContent", "onClose"]);
    const hashedOptions = (0, react_1.useMemo)(() => indexLabelByValue(options, groups), [options, groups]);
    const [value, selectedValue] = (0, react_1.useState)(initialValue);
    (0, react_1.useEffect)(() => {
        selectedValue(initialValue);
    }, [initialValue]);
    const [isOpen, setIsOpen] = (0, react_1.useState)(open);
    const [selectRef, setSelectRef] = (0, react_1.useState)(null);
    const [popperRef, setPopperRef] = (0, react_1.useState)(null);
    const { ref: managerRef, onDone, container } = (0, modal_manager_1.useManager)({ open: isOpen, lockPageScroll });
    const handleOuterClick = (event) => {
        if (!popperRef || popperRef.contains(event.target) || !selectRef || selectRef.contains(event.target))
            return;
        setIsOpen(false);
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('mousedown', handleOuterClick);
        return () => {
            document.removeEventListener('mousedown', handleOuterClick);
        };
    }, [popperRef, selectRef]);
    (0, react_1.useEffect)(() => {
        if (open)
            setIsOpen(open);
        if (hideOtherContent)
            onDone();
    }, [open]);
    (0, react_1.useEffect)(() => {
        if (!isOpen && onClose)
            onClose();
    }, [isOpen]);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const getSelectedValue = () => {
        if (!hashedOptions)
            return;
        return (value && hashedOptions[value]) || value || placeholder;
    };
    const onClickOption = (option) => () => {
        if (option.isDisabled)
            return;
        toggleDropdown();
        if (onChange)
            onChange(option);
    };
    const renderDisabledSelect = () => {
        return ((0, jsx_runtime_1.jsx)(Styled.DisabledSelectWrapper, { isFullWidth: isFullWidth, isNumber: isNumber, size: size, children: (0, jsx_runtime_1.jsxs)(Styled.DisabledSelect, { children: [(0, jsx_runtime_1.jsxs)(Styled.DisabledSelectText, { isNumber: isNumber, children: [(!!FixedIcon && ((0, jsx_runtime_1.jsx)(Styled.DisabledIconWrapper, { children: (0, jsx_runtime_1.jsx)(FixedIcon, {}) }))) ||
                                (!!Icon && ((0, jsx_runtime_1.jsx)(Styled.IconWrapper, { children: (0, jsx_runtime_1.jsx)(Icon, {}) }))), (0, jsx_runtime_1.jsxs)(Styled.SelectTextContent, { hasIcon: !!FixedIcon || !!Icon, children: [!!label && (0, jsx_runtime_1.jsx)(Styled.SelectLabel, { children: label }), (0, jsx_runtime_1.jsx)(Styled.SelectValue, { disabled: true, children: getSelectedValue() })] })] }), loading ? ((0, jsx_runtime_1.jsx)(Styled.StyledLoader, { butterfly: false, type: "secondary", width: "1.1rem", height: "1.1rem" })) : ((0, jsx_runtime_1.jsx)(Styled.DisabledChevronDown, {}))] }) }));
    };
    const renderSelect = () => {
        const Wrapper = hasError ? Styled.ErrorSelectWrapper : Styled.SelectWrapper;
        const ErrorLabel = hasError ? Styled.SelectErrorLabel : Styled.SelectLabel;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Wrapper, { isOpen: isOpen, isFullWidth: isFullWidth, isNumber: isNumber, size: size, ref: setSelectRef, children: [(0, jsx_runtime_1.jsxs)(Styled.Select, { onClick: toggleDropdown, children: [(0, jsx_runtime_1.jsxs)(Styled.SelectText, { isNumber: isNumber, isOpen: isOpen, children: [(!!FixedIcon && ((0, jsx_runtime_1.jsx)(Styled.IconWrapper, { children: (0, jsx_runtime_1.jsx)(FixedIcon, {}) }))) ||
                                            (!!Icon && ((0, jsx_runtime_1.jsx)(Styled.IconWrapper, { children: (0, jsx_runtime_1.jsx)(Icon, {}) }))), (0, jsx_runtime_1.jsxs)(Styled.SelectTextContent, { hasIcon: !!FixedIcon || !!Icon, children: [!!label && (0, jsx_runtime_1.jsx)(ErrorLabel, { children: label }), (0, jsx_runtime_1.jsx)(Styled.SelectValue, { disabled: isDisabled, children: getSelectedValue() })] })] }), (0, jsx_runtime_1.jsx)(Styled.ChevronDown, { "$isOpen": isOpen })] }), (0, jsx_runtime_1.jsx)(portal_1.default, { container, disablePortal, children: isOpen && ((0, jsx_runtime_1.jsx)(Options_1.Options, { groups,
                                managerRef,
                                onClickOption,
                                options,
                                placement,
                                popperRef,
                                selectRef,
                                setPopperRef,
                                size })) })] }), (helperText || errorMessage) && (0, jsx_runtime_1.jsx)(Message, { isError: hasError, children: helperText || errorMessage })] }));
    };
    return ((0, jsx_runtime_1.jsx)(Styled.DropdownWrapper, Object.assign({}, otherProps, { ref: forwardedRef, children: ((isDisabled || loading) && renderDisabledSelect()) || renderSelect() })));
});
exports.Dropdown.displayName = 'Dropdown';
exports.default = exports.Dropdown;
__exportStar(require("./Dropdown.types"), exports);
